import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { containerStyles } from "./product-own-review-banner.module.style";
import { Typography } from "@vc-workspace/utils-typography";
import { TailwindColors } from "@vc-workspace/utils-colors";
import StarIcon from '@mui/icons-material/Star';
import { UtilsSeparator } from "@vc-workspace/utils-separator";
import { DIMENSIONS } from "@vc-workspace/utils-dimens";
import { getKeyFromStorage, removeKeyFromSessionStorage, setKeyInSessionStorage } from "@vc-workspace/utils-helpers";
import { useEffect, useState } from "react";
import { getOwnProductReview } from "@vc-workspace/data-adapter";
import { MARKETPLACE_ACCESS_TOKEN, PageTypes } from "@vc-workspace/utils-constants";
import axios from "axios";
import Link from "next/link";
export function ProductOwnReviewBanner(props) {
  var _useState = useState(null),
      selfReview = _useState[0],
      setSelfReview = _useState[1];

  useEffect(function () {
    if (getKeyFromStorage(MARKETPLACE_ACCESS_TOKEN)) {
      axios.defaults.headers.common['x-access-token'] = getKeyFromStorage(MARKETPLACE_ACCESS_TOKEN);
      getOwnProductReview(props.sia.itemDetail.usId).then(function (review) {
        if (review.entityId) {
          setSelfReview(review);
        }
      })["catch"](console.log);
    }
  }, []);

  var onViewMyReview = function onViewMyReview() {
    removeKeyFromSessionStorage('PREFILLED_REVIEW');
    setKeyInSessionStorage('PREFILLED_REVIEW', JSON.stringify(selfReview), 15, true);
  };

  if (!selfReview) {
    return null;
  }

  return _jsxs(_Fragment, {
    children: [props.context.isMobileView ? _jsx(UtilsSeparator, {
      seperatorHeight: DIMENSIONS.px_4,
      color: TailwindColors.grey[100],
      borderRadius: DIMENSIONS.px_2,
      spacingTop: DIMENSIONS.px_8,
      spacingBottom: DIMENSIONS.px_8
    }) : null, _jsxs("div", {
      css: containerStyles,
      children: [_jsxs("div", {
        className: "flex items-center",
        children: [_jsx(Typography, {
          type: "Body1",
          color: TailwindColors.grey[900],
          semi_bold: true,
          children: "You have rated"
        }), _jsx(Typography, {
          type: "SubHeading1",
          color: TailwindColors.amber[500],
          className: "pl-2",
          semi_bold: true,
          children: selfReview.primaryEntryRating
        }), _jsx(Typography, {
          type: "Caption",
          color: TailwindColors.amber[500],
          className: "pl-px",
          children: _jsx(StarIcon, {
            fontSize: "small"
          })
        }), !props.context.isMobileView ? _jsx(Typography, {
          type: "Body1",
          color: TailwindColors.grey[400],
          className: "px-1",
          children: "\u2022"
        }) : null]
      }), _jsx(Link, {
        href: "/product/add-review/".concat(props.sia.itemDetail.usId, "?source=").concat(PageTypes.PRODUCT_REVIEW_PAGE),
        passHref: true,
        children: _jsx("a", {
          children: _jsx(Typography, {
            type: "Body1",
            color: TailwindColors.purple[800],
            onClick: onViewMyReview,
            semi_bold: true,
            underline: true,
            children: "See my review"
          })
        })
      })]
    })]
  });
}
export default ProductOwnReviewBanner;